import Modal from '../alerts/modal.js';


var xhr_request = null;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

export default class Api {

  /**
   * Ajax action (general)
   *
   * @return {PROMISE}
   */
  ajaxRequest(method, url, data = {}) 
  {
    const promise = $.Deferred();
    
    const params = {
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      dataType:'json',
      method:method,
      url:url,
      data:data,
      success: function(response)
      {
        promise.resolve(response);
      },
      error: function(xhr, status, error)
      {
        var response = xhr.responseText ? xhr.responseText : {error:'Response Error'};

        response = response.indexOf("<!DOCTYPE html>") && !response.error ? JSON.parse(xhr.responseText) : {error:'Session timeout'};

        // Toast response?
        if (response.hasOwnProperty('toast') && !response.toast) {
          promise.reject(response);
          return;
        }

        var error = response.error || 'Unknown error';
        
        // Timeout?
        if (error === 'Session timeout') {
          location.reload();
          return;
        }

        // Specific modal params?
        if (response.hasOwnProperty('modal')) {
          if (response.modal.hasOwnProperty('html')) {
            response.modal.content = document.createElement("span");
            response.modal.content.innerHTML = response.modal.html;
          }
          (new Modal).show(response.modal);
        // Default modal?
        } else {
          var title = response.title || 'Error';
          (new Modal).error(title, error, 'Ok'); 
        }

        promise.reject(response);
      }
    }
    if (method === 'DELETE') {
      params['type'] = 'POST';
    }
    xhr_request = $.ajax(params);
    
    return promise;
  }


  /**
   * Make a POST request
   *
   * @return {PROMISE}
   */
  postRequest(url, data = {}) 
  {
    return this.ajaxRequest('POST', url, data);
  }


  /**
   * Make a PATCH request
   *
   * @return {PROMISE}
   */
  patchRequest(url, data = {}) 
  {
    return this.ajaxRequest('PATCH', url, data);
  }


  /**
   * Make a GET request
   *
   * @return {PROMISE}
   */
  getRequest(url, data = {}) 
  {
    return this.ajaxRequest('GET', url, data);
  }

  /**
   * Make a DELETE request
   *
   * @return {PROMISE}
   */
  deleteRequest(url, data = {}) 
  {
    return this.ajaxRequest('DELETE', url, data);
  }

  /**
   * Make a PUT request
   *
   * @return {PROMISE}
   */
  putRequest(url, data = {}) 
  {
    return this.ajaxRequest('PUT', url, data);
  }


}